(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["1scp-chat-launcher"] && !Shopify.designMode) return;
  try {
    (() => {
    const button = document.querySelector('[data-scpd-chat]');
    if (!button) return;
    const unread = button.querySelector('[data-scpd-chat-unread]');

    // The Crisp app embed defines $crisp. Without it the chat is switched off, so the button stays hidden.
    const start = () => {
      // Crisp swaps the early $crisp queue for its own object once it loads, so every call reads it fresh.
      const push = (...command) => window.$crisp.push(command);

      const is = (state) => typeof window.$crisp.is === 'function' && window.$crisp.is(state);

      // Crisp ignores chat:hide while it is still drawing or closing, and reports "hidden" before its widget
      // is on the page, so the hide is repeated until the widget exists and stays hidden.
      const rest = (attempt = 0) => {
        button.hidden = false;
        push('do', 'chat:hide');
        setTimeout(() => {
          const drawn = document.querySelector('.crisp-client');
          if (attempt < 40 && !is('chat:opened') && !(drawn && is('chat:hidden'))) rest(attempt + 1);
        }, 150);
      };

      if (is('chat:opened')) {
        button.hidden = true;
      } else {
        rest();
      }

      push('on', 'chat:closed', () => rest());

      push('on', 'message:received', () => {
        if (button.hidden) return;
        unread.hidden = false;
      });

      button.addEventListener('click', () => {
        button.hidden = true;
        unread.hidden = true;
        push('do', 'chat:show');
        push('do', 'chat:open');
      });
    };

    if (window.$crisp) {
      start();
      return;
    }
    let tries = 0;
    const wait = setInterval(() => {
      tries += 1;
      if (window.$crisp) {
        clearInterval(wait);
        start();
      } else if (tries > 40) {
        clearInterval(wait);
      }
    }, 250);
  })();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["1scp-cursor"] && !Shopify.designMode) return;
  try {
    (() => {
    const el = document.querySelector('[data-scpd-cursor]');
    if (!el) return;

    const fine = window.matchMedia('(hover: hover) and (pointer: fine)');
    const still = window.matchMedia('(prefers-reduced-motion: reduce)');
    if (!fine.matches || still.matches) {
      el.remove();
      return;
    }

    const EASE = 0.13;
    const OFFSET_X = 18;
    const OFFSET_Y = 18;

    let targetX = -100;
    let targetY = -100;
    let x = -100;
    let y = -100;
    let running = false;

    const frame = () => {
      x += (targetX - x) * EASE;
      y += (targetY - y) * EASE;
      el.style.transform = `translate3d(${x + OFFSET_X}px, ${y + OFFSET_Y}px, 0)`;

      if (Math.abs(targetX - x) > 0.1 || Math.abs(targetY - y) > 0.1) {
        requestAnimationFrame(frame);
      } else {
        running = false;
      }
    };

    const wake = () => {
      if (running) return;
      running = true;
      requestAnimationFrame(frame);
    };

    document.addEventListener(
      'mousemove',
      (event) => {
        targetX = event.clientX;
        targetY = event.clientY;
        el.classList.add('is-visible');
        wake();
      },
      { passive: true }
    );

    // A modal dialog opens above everything, so the mark is lifted back over it each time one opens.
    const raise = () => {
      if (!el.showPopover) return;
      if (el.matches(':popover-open')) el.hidePopover();
      el.showPopover();
    };
    raise();
    new MutationObserver((changes) => {
      if (changes.some((change) => change.target.matches?.('dialog[open]'))) raise();
    }).observe(document.body, { subtree: true, attributeFilter: ['open'] });

    document.addEventListener('mouseleave', () => el.classList.remove('is-visible'));
    document.addEventListener('mouseenter', () => el.classList.add('is-visible'));
  })();
  } catch(e) { console.error(e); }
})();

})();
